import { EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type SupportLinkEvents =
  | 'OPEN_ADD_LINK'
  | 'LINK_ADDED'
  | 'OPEN_DELETE_LINK'
  | 'LINK_DELETED'
  | 'OPEN_EDIT_LINK'
  | 'LINK_EDITED'
  | 'LINKS_REORDERED';

export const supportLinks: Record<SupportLinkEvents, MixpanelEvent> = {
  OPEN_ADD_LINK: {
    eventDescription: 'Settings Support Links - Open Add Link Dialog',
    eventKey: 'client-support-links-open-add-link',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  LINK_ADDED: {
    eventDescription: 'Settings Support Links - Link Added',
    eventKey: 'client-support-links-link-added',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A
  },
  OPEN_DELETE_LINK: {
    eventDescription: 'Settings Support Links - Open Delete Link Dialog',
    eventKey: 'client-support-links-open-delete-link',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  LINK_DELETED: {
    eventDescription: 'Settings Support Links - Link Deleted',
    eventKey: 'client-support-links-link-deleted',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A
  },
  OPEN_EDIT_LINK: {
    eventDescription: 'Settings Support Links - Open Edit Link Dialog',
    eventKey: 'client-support-links-open-edit-link',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  LINK_EDITED: {
    eventDescription: 'Settings Support Links - Link Edited',
    eventKey: 'client-support-links-link-edited',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A
  },
  LINKS_REORDERED: {
    eventDescription: 'Settings Support Links - Links Reordered',
    eventKey: 'client-support-links-link-reordered',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.DROP
  }
} as const;
